// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner-box h3[data-v-2e0f0205]{text-align:center}", ""]);
// Exports
module.exports = exports;
